import { motion } from "framer-motion";
import { profile } from "../data/portfolio";

const easeOut = [0.22, 1, 0.36, 1];

export const Footer = () => {
  return (
    <footer
      id="contact"
      className="bg-[#0a0a0a] text-[#f4f4f0] pt-16 lg:pt-20 pb-8"
      data-testid="footer-section"
    >
      <div className="container-portfolio">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: easeOut }}
          className="grid grid-cols-12 gap-8 lg:gap-12 items-start"
        >
          {/* Get in touch */}
          <div className="col-span-12 lg:col-span-5">
            <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-white/40 mb-3">
              Get in touch
            </p>
            <a
              href={`mailto:${profile.email}`}
              className="text-xl sm:text-2xl font-bold tracking-tight hover:text-[#FF3B30] transition-colors inline-block break-all"
              data-testid="footer-email-link"
            >
              {profile.email}
            </a>
            {profile.phone && (
              <p className="mt-2 text-sm font-light text-white/65">
                {profile.phone}
              </p>
            )}
          </div>

          {/* Elsewhere */}
          <div className="col-span-6 lg:col-span-4">
            <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-white/40 mb-3">
              Elsewhere
            </p>
            <ul className="space-y-1.5">
              {profile.socials.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm font-medium tracking-tight text-white/90 hover:text-[#FF3B30] transition-colors inline-flex items-center gap-2"
                    data-testid={`footer-social-${s.label.toLowerCase().replace(/\s|·/g, "-")}`}
                  >
                    {s.label}
                    <span aria-hidden className="text-white/40">↗</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Studio */}
          <div className="col-span-6 lg:col-span-3">
            <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-white/40 mb-3">
              Studio
            </p>
            <p className="text-sm font-medium tracking-tight text-white/90">
              {profile.location}
            </p>
            <p className="mt-1 text-xs font-light text-white/55">
              GMT+5:30 · Working hours 10–7
            </p>
          </div>
        </motion.div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row justify-between gap-3 text-[11px] font-medium tracking-wide text-white/40">
          <span>
            © {new Date().getFullYear()} — {profile.name}. Hand-set in Outfit.
          </span>
          <span>Designed in Hyderabad.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
